import { useMutation } from '@tanstack/react-query';

import { type DSKPaymentProvider } from 'src/features/parkingManagement/api/paymentPaymentProviders/useGetDSKPaymentProvider';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
    id: string;
}
const RESOURCE = '/parkings/:parkingId/dsk-payment-provider/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<Omit<DSKPaymentProvider, 'id'>> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateDSKPaymentProvider };
